export const API_ROOT = {
  development: 'http://xl-gateway.srv.test.shortvideo.szcsckj.com',
  test: 'http://xl-gateway.srv.test.shortvideo.szcsckj.com',
  production: 'https://api-shortvideo-xc.szxlxzb.com',
}[ENV]

export const headers = {
  'content-type': 'application/x-www-form-urlencoded',
}
// share渠道
export const PP_YYB_DEFAULT =
  'http://a.app.qq.com/o/simple.jsp?pkgname=com.xunlei.downloadprovider&ckey=CK1401484575849'
export const PP_YYB_DEFAULT_KEY = 'CK1401484575849'
export const PP_YYB_SMALL_KEY = 'CK1466017798492'

export const PP_PKG_NAME = 'com.xunlei.downloadprovider'
export const PP_SPEED_PKG_NAME = 'com.xunlei.downloadprovider'
// 安卓包
export const PP_ANDROID =
  'https://apk.izuiyou.com/download/zuiyou_lite.latest.yyb_xin.apk'

// 苹果市场
export const PP_IOS =
  'https://itunes.apple.com/cn/app/apple-store/id1423061888?pt=117916472&ct=yyb_share&mt=8'

export const APP_NAME = 'Dokimo'
